import { CommonModule }      from '@angular/common';
import { NgModule }          from '@angular/core';
import { GroupComponent }    from '@app/shared/components/group/group.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule( {
	declarations: [
		GroupComponent
	],
	imports: [
		CommonModule,
		NgbCollapseModule
	],
	exports: [
		GroupComponent
	]
} )
export class GroupModule {}
